import { CheckCircle2 } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { Card } from '../../components/ui/Card';
import { Button } from '../../components/ui/Button';

export function EmailConfirmedPage() {
  const navigate = useNavigate();
  return (
    <Card className="flex flex-col items-center gap-4 p-8 text-center">
      <div className="flex h-16 w-16 items-center justify-center rounded-full bg-green-100 text-[color:var(--success)]">
        <CheckCircle2 size={32} />
      </div>
      <h1 className="text-2xl font-semibold">Email подтверждён</h1>
      <p className="text-sm text-text-muted">
        Пробный тариф активирован. Можно начинать — загрузите первый файл и
        получите распознанный текст за 30 секунд.
      </p>
      <Button fullWidth size="lg" onClick={() => navigate('/login')}>
        Войти
      </Button>
    </Card>
  );
}
